import restClient from "../restClient";

const endpoint = "/notes";

export const getNotes = async ( page = 1, pageSize = 10, key, module, id) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    let url = `${endpoint}?pagination[page]=${page}&pagination[pageSize]=${pageSize}`;
    if (key) url += `&key=${key}`;
    if (module) url += `&module=${module}`;
    if (id) url += `&id=${id}`;
    const response = await restClient.get(url, config);
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const createNote = async (data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.post(endpoint, { data }, config);
    return response.data;
  } catch (err) {
    throw err;
  }
}; 